module.exports = __webpack_public_path__ + "media/pl_pl_s6_Zuzanna.ed23a93e.oga";